export const IS_PROD = import.meta.env.MODE === "production";
export const IS_STAGING = import.meta.env.MODE === "development"; // we're using development mode for staging
export const IS_DEVELOPMENT = import.meta.env.DEV; // run the app in development mode (npm run dev)

export const REFFERAL_CREDIT_VALUE = 2; // 2 credits for each referral
export const CREDIT_VALUE_IN_POUNDS = 2.5; // 1 credit = 2.5 pounds